export const INSURANCE_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  timeZone: 'UTC',
}

export const MODAL_NAMES = {
  COVERAGE_DETAILS_DRAWER: 'coverage-details-drawer',
  PAYMENT_HISTORY_DRAWER: 'payment-history-drawer',
}

export const ROUTE_NAMES = {
  POLICY_DETAILS: 'insurance-policy-details',
}

export const PARTNER_WEBSITE_URL = {
  EVY: 'https://backmarket.customers.evy.eu/en',
  BOLT: 'https://uatportal.boltinsurance.com/uat/ui/backmarket',
  BOLTTECH_JP: 'https://backmarket.bolttech.jp/#/ ',
  ASURION:
    'https://protection.asurion.com/protection-plan/en-us/?cid=vn-rtm:backmarket',
  BOLTTECH_EU: 'https://backmarket.bolttech.eu/',
  BOLTTECH_UK: 'https://backmarket-uk.bolttech.eu/',
}
